// src/components/strumenti/RipartizioneImporto.js — W442. Ripartizione di un importo per quote, al centesimo
import React from "react";
import { useCampi, Campo, Testo, Risultato, Formula, Azzera, Avviso, euro, fmt } from "./UiStrumento";
import { ripartisci } from "../../utils/calcoliStrumenti";
import { leggiNumero } from "../../utils/numeriStrumenti";

/** «Nome ; quota» per riga (anche tabulazione). Senza nome: «Quota 1», «Quota 2»… */
export function righeQuote(testo) {
  const out = [], errate = [];
  String(testo || "").split("\n").map(r => r.trim()).filter(Boolean).forEach((r, i) => {
    const p = r.split(/[;\t]/);
    const quota = leggiNumero(p.length > 1 ? p[1] : p[0]);
    const nome = p.length > 1 ? p[0].trim() : `Quota ${i + 1}`;
    if (!Number.isFinite(quota) || quota < 0) errate.push(i + 1); else out.push({ nome, quota });
  });
  return { righe: out, errate };
}

export default function RipartizioneImporto() {
  const { v, set, n, azzera } = useCampi({ importo:"", quote:"" });
  const { righe, errate } = righeQuote(v.quote);
  const r = righe.length ? ripartisci(n("importo"), righe.map(x => x.quota)) : null;
  return (
    <div>
      <div style={{ marginBottom:12 }}><Campo etichetta="Importo da ripartire (€)" valore={v.importo} onChange={set("importo")} placeholder="Es. 1.234,56"/></div>
      <div style={{ marginBottom:12 }}>
        <Testo etichetta="Quote, una per riga: nome ; quota" valore={v.quote} onChange={set("quote")} placeholder={"Rossi ; 250\nBianchi ; 300\nVerdi ; 450"} righe={5} aiuto="Le quote possono essere percentuali, millesimi, m², ore… conta solo il rapporto tra loro."/>
      </div>
      {errate.length > 0 && <Avviso>Righe non lette: {errate.join(", ")} (la quota deve essere un numero non negativo).</Avviso>}
      <Risultato settore="amministrativo" titolo="Totale ripartito" valore={r ? euro(r.righe.reduce((t, x) => t + x.importo, 0)) : "—"}
        righe={r ? [...r.righe.map((x, i) => [`${righe[i].nome} (${fmt(x.percentuale, 2)}%)`, euro(x.importo)]), r.arrotondamento !== 0 && ["Arrotondamento sull'ultima riga", euro(r.arrotondamento)]] : []}/>
      <Formula>Parte = importo × quota ÷ somma delle quote, arrotondata al centesimo. La differenza di arrotondamento (al massimo pochi centesimi) va sull'ultima riga, così il totale torna esatto.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
